export default __webpack_public_path__ + "static/media/calcium.5bc449a5.jpg";